<template>
	<div>
		<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
		<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
		<div class="maxContainer subscriptionPlan" v-if="vpsDetail != '' && vpsDetail.length > 0 && !pageLoader"> 
			<div class="mainTitle p-0 d-flex align-items-center justify-content-between text-center my-3">
				<h3 class="mb-2"> {{$t('VPSDetail')}}</h3>

				<router-link :to="'/vps-list'" class="btn_sm prism_btn "  data-placement="top"  data-toggle="tooltip">{{$t('backVPSlist')}}</router-link>
			</div> 
			<div class="tablePmm table-responsive mb-5">
                <table class="table pmmTable" >
                    <thead>
                        <tr>
                            <th>{{$t('IPAddress')}} :</th>
                            <th>{{$t('ServerId')}} :</th>
							<th>{{$t('HostName')}} : </th>
                            <th>{{$t('amount')}}</th>
							<th>{{$t('Disk')}}</th>
							<th>{{$t('Cpu')}}</th>
                            <th>{{$t('Memory')}}</th>
							<th>{{$t('State')}}</th>	
							<th>{{$t('Created')}}</th>	
							<th>{{$t('action')}}</th>							
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                        	 
                            <td>{{vpsDetail[0].main_ip_address}}</td>
                             <td> {{vpsDetail[0].server_id}}</td>
                             <td>{{vpsDetail[0].hostname}}</td>
                             <td> {{vpsDetail[0].amount}}</td>
                             <td>{{vpsDetail[0].disk}}</td>
                             <td>{{vpsDetail[0].cpu}}</td>
                             <td>{{vpsDetail[0].memory}}</td>
                             <td>{{vpsDetail[0].state}}</td>
                             <td>{{vpsDetail[0].created  | moment("DD MMMM YYYY")}}</td>
                             <td>
                             	<a href="#" class=" powerico" title="Shut-Down" @click="vpsOper('1')" ><feather type="power" size="1em"></feather> <!-- {{$t('ShutDown')}} --></a>
								<a href="#" class=" rebootico" title="Restart" @click="vpsOper('0')" > <feather type="refresh-ccw" size="1em"></feather>  <!-- {{$t('Restart')}} --></a>
								<a href="#" class=" rebootico" title="Reboot" @click="vpsOper('2')"><feather type="refresh-ccw" size="1em"></feather>  <!-- {{$t('Reboot')}} --></a>
								<a href="#" class=" passwordico" title="Change-Password" @click="passwordTabShow = true"> <feather type="lock" size="1em"></feather>  <!-- {{$t('changePassword')}} --></a> 
                             </td>
                        </tr>
                    </tbody>
                </table> 
            </div> 
			 
			<div  v-if="passwordTabShow"> 
				<div class="mainTitle text-center mt-4 mb-3">
					<h3 class="uppercase mb-4"> {{$t('changePassword')}}</h3>
				</div>
				<div class="CustomBlockWidth inMiddle-area whitebox p-4 position-relative">
					<a class="closeButton" href="#" @click="passwordTabShow = false ; new_password = '' ; confirm_password = '' ; submitted = false">
						<feather type="x"></feather>
					</a>
					<div class="justify-content-center">
						<div class="form-group field-wrapper dob">
							<input placeholder=" " :type="inputtype1" v-model="new_password"   class="float-field form-control"  v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])\S{12,24}$/}"   :class="{ 'is-invalid': submitted && errors.has('new_password') }"    ref="new_passwordInput" name="new_password" />
							<label for="password" class="float-label"> {{$t('password')}}</label>
							<feather :type="iconType1" class="toggle-password" @click="switchVisibility('1')"></feather>
							<p class="error" v-for="error in errors.collect('new_password')">
								<span v-show="error == 'The new_password field is required.'">{{$t('passwordFieldReq')}}</span>
								<span v-show="error == 'The new_password field format is invalid.'">{{$t('passWordMustContain12')}}</span>
							</p>
						</div> 
						<div class="form-group field-wrapper dob">
							<input placeholder=" " :type="inputtype2" v-model="confirm_password"  class="float-field form-control" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])\S{12,24}$/, confirmed:new_password}"  :class="{ 'is-invalid': submitted && errors.has('confirm_password') }" ref="confirm_passwordInput" name="confirm_password"  />
							<label for="password" class="float-label"> {{$t('conPassword')}}</label>
							<feather :type="iconType2" class="toggle-password" @click="switchVisibility('2')"></feather>
							<p class="error" v-for="error in errors.collect('confirm_password')">
								<span v-show="error == 'The confirm_password field is required.'">{{$t('passwordFieldReq')}}</span>
								<span v-show="error == 'The confirm_password field format is invalid.'">{{$t('passWordMustContain12')}}</span>
								<span v-show="error == 'The confirm_password confirmation does not match.'">{{$t('newConfFieldSame')}}</span>
							</p>
						</div>
						<div class="submitButton d-flex justify-content-center align-items-center w-100 mt-2 text-center">
							<a href="#" class="prism_btn btn_sm" title="Change-Password" @click="vpsOper('3')"> {{$t('changePassword')}}</a>
						</div>
					</div>
					
					
				</div>
			</div>
		</div>
		<div class="text-center p-5 customLoader" v-else-if="pageLoader" > 
			<h4>{{$t('plzWaitWhileProc')}}</h4>
		</div> 
		<div class="CustomBlockWidth " v-else > 
			<div class="card ">
			  <div class="card-body text-center">
				<img src="../../../../static/fxView/images/lost.svg" alt="no account found" class="mb-4" width="200">  
				<!-- Text -->
				<span>
					<p class="text-muted mb-3" >
					  {{$t('noData')}}
					</p>  
					<router-link :to="'/vps-list'" class="prism_btn btn_sm lift"  data-placement="top"  data-toggle="tooltip">{{$t('backVPSlist')}}</router-link>
				</span> 
				  
			  </div>
			</div>
		</div>
	</div>
</template>
<script> 
	import { fxViewMixins } from '@/plugins/fxView'
	import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	export default {
		name: 'VPS-Detail',
		mixins: [fxViewMixins],
		data() {
			return {
				//============message and loader ===========
				response_msg : '',
				msg_type : '',
				pageLoader : false,
				//==========================================
				passwordTabShow : false,
				submitted : false,
				new_password : '',
				confirm_password : '',
				inputtype1 : 'password',
                inputtype2 : 'password',
				iconType1 : 'eye-off',
                iconType2 : 'eye-off',
                showpassword1 : false,
                showpassword2 : false
			}
		},
		methods:{
			reset(){
				this.passwordTabShow = false
				this.submitted = false
				this.new_password = ''
				this.confirm_password = ''
			},
			switchVisibility(getData) {
                if(getData == '1'){
                    this.showpassword1 = !this.showpassword1
                    if(this.showpassword1){
                        this.inputtype1 = 'text'
                        this.iconType1 = 'eye'
                    }else{
                        this.inputtype1 = 'password'
                        this.iconType1 = 'eye-off'
                    } 
                }else if(getData == '2'){
                    this.showpassword2 = !this.showpassword2
                    if(this.showpassword2){
                        this.inputtype2 = 'text'
                        this.iconType2 = 'eye'
                    }else{
                        this.inputtype2 = 'password'
                        this.iconType2 = 'eye-off'
                    } 
                }
            },
			vpsOper(getData){
				let input_json={
                    'globalParams' :{
                        'server_id' : this.$route.query.server_id
                    },
                    'localParams' :{ "parameter" : this}
                }
				if(getData == '0'){
					this._runVpsRestart(input_json)
				}else if(getData == '1'){
					this._runVpsShutdown(input_json)
				}else if(getData == '2'){
					this._runVpsReboot(input_json)
				}else if(getData == '3'){
					const _that = this
					_that.submitted = true;
					_that.$validator.validate().then(valid => {
						if (valid) {
							input_json.globalParams.password  = _that.new_password
							_that._runVpsChangePassword(input_json)
						}else{
							_that.handleValidationErrorAdvanced(_that.errors)
						}
					});
				}
			},
			detail(){
                let input_json={
                    'globalParams' :{
                        'vps_id' : (this.$route.query.vps_id).toString(),
						"server_id" : this.$route.query.server_id
                    },
                    'localParams' :{ "parameter" : this}
                }
                this._runGetVpsDetail(input_json)
            },
		},
		created(){
			this.detail()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/vpsDetail.vue